import React from "react";
import Box from "@mui/material/Box";

const EmptyLayout = ({ children }) => {
  return (
    <Box
      sx={{
        overflowX: "hidden",
        minHeight: "100vh",
        width: "100vw",
        bgcolor: "background.default",
      }}
    >
      {children}
    </Box>
  );
};

export default EmptyLayout;
